<div class="grid grid-cols-4 gap-2">
  <div class="flex flex-col" *ngFor="let key of paddingKeys">
    <label [tailLabel]="i">{{getPaddingLabel(key)}}</label>
    <input type="number" #i="input" tailInput [(ngModel)]="value[key]">
  </div>
</div>
